var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivityLines = function SvgActivityLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13a1 1 0 1 1 2 0 1 1 0 0 1-2 0M0 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0M0 19a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 19a1 1 0 1 1 2 0 1 1 0 0 1-2 0M8 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 13a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1M4 1a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1M8 19a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1M12 7a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"
  })));
};
export default SvgActivityLines;